<template>
	<li class="shop_card_container">
		<div @click="handleClick">
			<div class="heading_8">
				{{ name }}
				<div v-if="setBest()" class="best_shop_label f_gray_12 body_10_M" >
					평점우수업체
				</div>
			</div>
			<p class="body_10 f_gray_3">{{ address }}</p>
			<div>
				<strong class="heading_10 f_primary_1">{{ distance }}</strong>
				<a class="body_11 f_gray_4" :href="`tel:${contact}`">{{ contact }}</a>
			</div>
		</div>
		<Button :label="getButtonLabel()" :size="36" :full="false" :disabled="status !== 'NY'"
			:onClick="()=>handleSendEstimate(agentNo)" />
		<Alert :isVisible="isSuccess" :title="'매장에서 상담을 위해\n연락드릴 예정이에요'" :content="'견적 전송이 완료되었어요'"
			:secondaryText="'닫기'" :onClickSecondary="handleAlertClose" />
		<!-- 고객센터 번호 확인 필요 -->
		<Alert :isVisible="isError" :title="'견적 전송에 실패했어요'" :content="`다시 시도하시거나\n지속적인 오류 발생 시 고객센터로 연락해주세요\n(1600-1600)`
			" :secondaryText="'닫기'" :primaryText="'다시 시도'" :onClickSecondary="handleAlertClose" :onClickPrimary="handleRetry" />
	</li>
</template>

<script>
import Vue from 'vue'
import Button from '../AiButton.vue'
import Alert from '../AiAlert.vue'
import AppConfig from '@/config'

export default {
	props: {
		name: {
			type: String
		},
		address: {
			type: String
		},
		distance: {
			type: String
		},
		contact: {
			type: String
		},
		agentNo: {
			type: String
		},
		estimateSeq: {
			type: String
		},
		datEstimateNo: {
			type: String
		},
		status: {
			type: 'NN' | 'NY' | 'YN' | 'YY',
			default: 'YY'
		},
		onClick: {
			type: Function
		},
		onLabelClick: {
			type: Function
		},
		isBest: {
			type: String
		}

	},
	components: {
		Button,
		Alert,
		AppConfig
	},
	data() {
		return {
			isSuccess: false,
			isError: false
		}
	},
	methods: {
		setBest(){
			switch(this.isBest){
				case 'Y':
					return true;
				default:
					return false;
			}
		},
		getButtonLabel() {
			switch (this.status) {
				case 'NY':
					return '견적전송'
				case 'YY':
					return '전송완료'
				case 'YN':
					return '불가매장'
				case 'NN':
					return '불가매장'
			}
		},

		handleSendEstimate(agentNo){
			this.fnSaveFirstHistory(agentNo)
			// this.fnSendEstimate(agentNo);
		},

		fnSaveFirstHistory(agentNo){
			this.isSuccess = false
			this.isError = false

			var params = {
				estimateSeq : this.estimateSeq,
				datEstimateNo: this.datEstimateNo,
				partnerNo : agentNo
			}
			Vue.httpClient
			.post('/m/ai/dat/estimate/beforeSendEstimate', params)
			.then((response) => {
				if (response.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
					this.isSuccess = true;
					params.sendSeq = response.data.result.sendSeq;

					this.fnSendEstimate(params);
				} else {
					this.isError = true
				}
			})
			.catch((error)=>{
				this.isError = true
			})
			.finally(()=>{
				this.$emit('refreshShopList')
			});
		},

		async fnSendEstimate(params) {
			Vue.httpClient
			.post('/m/ai/dat/estimate/sendEstimateRepairShop', params)
			.then((response) => {
				if (response.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
				// 	this.isSuccess = true
				// } else {
				// 	this.isError = true
				}
			})
			.catch((error)=>{
				// this.isError = true
			})
			.finally(()=>{
				// this.$emit('refreshShopList')
			})
		},
		handleAlertClose() {
			this.isSuccess = false
			this.isError = false
		},
		handleRetry() {
			this.firstStep = false
			this.secondStep = false
			setTimeout(() => {
				this.handleSendEstimate(this.agentNo);
			}, 300);
		},

		handleClick() {
			if (!this.disabled) {
				this.onClick()
			}
		}

	},
}
</script>

<style scoped>
.shop_card_container {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;
	padding: 16px 20px;
}

.shop_card_container>div>div {
	display: flex;
	align-items: center;
	gap: 4px;
}

.best_shop_label {
	background-color: var(--secondary-color-4);
	border-radius: 4px;
	padding: 1px 4px;
	margin-left: 4px;
}

</style>



// WEBPACK FOOTER //
// src/components/ai/card/AiShopCard.vue